export default __webpack_public_path__ + "ceee44de40aceb1ec9344c54ac482e5f.svg";